<div class="ion-page" autocomplete="off">
    <ion-header>
        <upp-header color="primary" height="62px">
            <upp-header-content>
                <ion-label>{{tr('@login_user_registration_title')}}</ion-label>
            </upp-header-content>  
            <upp-header-button uppDataid="register-close-button" (click)="CloseView()">
                <ion-icon name="close-outline"></ion-icon>
            </upp-header-button>                  
        </upp-header>
    </ion-header>
    <ion-content [scrollY]="false">
        <upp-scrollable class="auth-scroll">
            <div style="margin: 0px 2px">
                <div class="greeting" [class.mobile]="view.Mobile">
                    <h1>{{tr('@register_welcome')}}</h1>
                    <h2>{{tr('@register_provide_basic_data')}}</h2>
                </div>
                <form class='register-form' [formGroup]="RegistryForm">
                    <ion-list>
                        <ion-item lines="none">
                            <upp-input uppDataid="register-username-text" 
                                formControlName="username" 
                                type="email" 
                                autocomplete="username" 
                                placeholder="{{tr('@register_username_placeholder')}}" 
                                title="{{tr('@register_username')}}"
                                [errornfo]="{ required: tr('@mandatory_field'), email: tr('@enter_valid_email'), available: tr('@register_username_not_available') }">
                            </upp-input>
                        </ion-item>        
                        <ion-item lines="none">
                            <upp-input uppDataid="register-password1-text" 
                                formControlName="password" 
                                type="password" 
                                autocomplete="current-password" 
                                placeholder="{{tr('@register_passsword_placeholder')}}" 
                                title="{{tr('@register_password')}}"
                                [errornfo]="{ required: tr('@mandatory_field'), minlength: tr('@minsize_field', [ '8' ]) }">
                            </upp-input>
                        </ion-item>        
                        <ion-item lines="none">
                            <upp-input uppDataid="register-password2-text" 
                                formControlName="confirm" 
                                type="password" 
                                autocomplete="new-password" 
                                placeholder="{{tr('@register_confirm_placeholder')}}" 
                                title="{{tr('@register_confirm')}}"
                                [errornfo]="{ required: tr('@mandatory_field'), minlength: tr('@minsize_field', [ '8' ]), nomatch: tr('@register_password_doesnt_match') }">
                            </upp-input>
                        </ion-item>        
                    </ion-list>
                    <div class="checkbox-with-link" style="margin-top: 15px;">
                        <ion-checkbox uppDataid="register-license-check" mode="md" formControlName="licence"></ion-checkbox>
                        <ion-label>{{tr('@register_accept_licence')}} 
                            <a uppDataid="register-license-link" style="z-index:1;" tabindex="0" (click)="ShowLicence($event)" (keydown.enter)="ShowLicence($event)" (keydown.space)="ShowLicence($event)">
                                {{tr('@register_show_licence_link')}}
                            </a>
                        </ion-label>
                    </div>
                </form>
            </div>
        </upp-scrollable>
    </ion-content>
    <ion-footer mode='ios'>
        <ion-grid>
            <ion-row>
                <ion-col class="ion-align-self-stretch">
                    <ion-button [attr.data-id]="'register-cancel-button'" color="medium" expand="block" (click)="CloseView()">
                        {{tr('@register_do_cancel_button')}}
                    </ion-button>
                </ion-col>
                <ion-col class="ion-align-self-stretch"> 
                    <ion-button [attr.data-id]="'register-submit-button'" color="primary" expand="block" [disabled]="!RegistryForm.valid" (click)="DoRegister()">
                        {{tr('@register_do_register_button')}}
                    </ion-button>
                </ion-col>
            </ion-row>        
        </ion-grid>    
    </ion-footer>            
</div>